<template>
    <el-drawer title="敏感词检测结果" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
        @close="close">
        <div class="drawer-content">
            <h3 v-if="data" class="info">文件：{{ data.name }}</h3>
            <div class="page-list-box">
                <el-table :data="dataList" border style="width: 100%" v-loading="listLoading" size="small" stripe empty-text="文档未检测出敏感词">
                    <el-table-column prop="type" label="类型"></el-table-column>
                    <el-table-column prop="words" label="敏感词"></el-table-column>
                </el-table>
            </div>
            <!-- <div v-if="data" class="page-pagination-box">
                <el-pagination background @size-change="handleSizeChange" @current-change="getDataList"
                    :current-page.sync="params.pageNo" :page-sizes="$pageSizes" :page-size.sync="params.pageSize"
                    layout="total, sizes, prev, pager, next" :total="data.totalCount || 0">
                </el-pagination>
            </div> -->
        </div>

        <div class="drawer-footer">
            <el-button @click="close">关闭</el-button>
        </div>
    </el-drawer>
</template>

<script>
const defaultParams = {
    pageNo: 1,
    id: '',
}
export default {
    data() {
        return {
            drawerShow: false,
            listLoading: false,
            data: null,
            dataList: [],
            params: {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
        }
    },
    methods: {
        close() {
            this.dataList = [];
            this.data = null;
            this.drawerShow = false;
            this.listLoading = false;
            this.params = {
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            }
        },
        show(id) {
            this.params.id = id;
            this.getDataList();
            this.drawerShow = true;
        },
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/document/result",
                method: "POST",
                params: {
                    ...this.params
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.list || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
       
    }
}
</script>

<style lang="scss" scoped>
</style>